import { getRequiredFieldErrors } from "../utils";

const REQUIRED_FIELDS = ["name", "triggerType"];

export function validateAchievement(values: any) {
  return getRequiredFieldErrors(values, REQUIRED_FIELDS);
}
